import { organizationManagementApiV1 as organizationManagementApi } from '@deepup/apis';
import {
  commonApiV1 as commonApi,
  iorganizationManagementApiV1 as iorganizationManagementApi,
} from '@deepup/internal-apis';

/**
 * Default `listProjectInfos` filters shared by Back Office call sites (match OMA list defaults).
 */
export const buildDefaultListProjectInfosRequest = (ids: string[]) => ({
  permission: '',
  organizationId: '',
  name: '',
  ids,
  geolocationThreshold: 0,
  sortBy: iorganizationManagementApi.StreamProjectInfosRequest_SortBy.UNSPECIFIED,
  sortOrder: commonApi.SortOrder.ASC,
  networkProviderId: '',
  generalContractorId: '',
  serviceProviderId: '',
  customerManagerNameOrEmailLike: '',
  contactPersonNameOrEmailLike: '',
  internalContactPersonNameOrEmailLike: '',
  networkDesignState: iorganizationManagementApi.NetworkDesignState.UNSPECIFIED,
  networkDesignFormat: iorganizationManagementApi.NetworkDesignFormat.UNSPECIFIED,
  pipeDirectionEnabled: commonApi.BoolFilter.UNSPECIFIED,
  type: organizationManagementApi.ProjectType.UNSPECIFIED,
  labelingType: iorganizationManagementApi.LabelingType.UNSPECIFIED,
  includeArchived: false,
});
